const pageTitle = {};

export default pageTitle;
